<div class="top-bar">

    <div class="left">
        <img src="../../../assets/icons/1p Logo.svg" class="header-logo" />
    </div>

    <div class="right">
        <button mat-button [matMenuTriggerFor]="langMenu" class="lang-btn">
            <mat-icon>language</mat-icon>
            <span class="lang-label">{{ languageService.currentLanguage().toUpperCase() }}</span>
            <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #langMenu="matMenu">
            @for (lang of languages; track lang.code) {
                <button mat-menu-item
                        (click)="languageService.setLanguage(lang.code)"
                        [class.lang-active]="languageService.currentLanguage() === lang.code">
                    <span>{{ lang.nativeLabel }}</span>
                </button>
            }
        </mat-menu>

        <button mat-icon-button
                class="theme-toggle-btn"
                (click)="themeService.toggle()"
                [matTooltip]="themeService.isDark() ? 'Switch to light mode' : 'Switch to dark mode'">
            @if (themeService.isDark()) {
                <mat-icon>light_mode</mat-icon>
            } @else {
                <mat-icon>dark_mode</mat-icon>
            }
        </button>
    </div>

</div>
